<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Quiz Mark Analysis Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" :items="ay_list"
                        item-text="ay" item-value="id" label="Select Academic Year" outlined persistent-hint
                        hint="Please Select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_standard"
                        :items="standard_list" item-text="standard" item-value="id" label="Please Select Standard"
                        outlined persistent-hint hint="Please Select Standard" @change="getDivisions" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_division"
                        :items="division_list" item-text="division_name" item-value="id" label="Please Select Division"
                        outlined persistent-hint hint="Please Select Division" />
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_course"
                        :items="course_list" item-text="course_name" item-value="id" label="Please Select Subject"
                        outlined persistent-hint hint="Please Select Subject" @change="getQuizzes" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_quiz"
                        :items="quiz_list" item-text="quiz_name" item-value="quiz_id" label="Please Select Quiz"
                        outlined persistent-hint hint="Please Select Quiz" />
                </v-col>
            </v-row>
            <v-row justify="center" align="center" dense class="no-display">
                <v-col cols="auto">
                    <v-btn class="mt-6 button"
                        @click="getreport()"
                        :loading="fetch_loader"
                        >
                            Fetch
                    </v-btn>
                </v-col>
            </v-row>


            <v-row justify="center" class="mt-10">
                <v-col cols="12">
                    <span v-if="report_data && report_data.length">
                        <span>
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                    left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>

                            <v-btn rounded class="no-display" color="success" outlined @click="downloadFile"
                                :loading="loader">
                                <v-icon color="success">mdi-export</v-icon>Export
                            </v-btn>

                            <div class="printing_area">
                                <div class="header">
                                    <v-row dense align="center" class="mb-3 py-2 print-header" style="width: 100%;">
                                        <v-col cols="12" sm="4" md="2" class="text-left trust-logo">
                                            <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo"
                                                alt="Trust Logo" style="height: 120px; margin-left: 40px;" />
                                        </v-col>

                                        <v-col cols="12" sm="4" md="8" class="text-center">
                                            <h2 style="margin: 0; font-size: 20px; font-weight: 700;">{{
                                                org_basic_data.trust_name }}</h2>
                                            <h2 style="margin: 0; font-size: 20px; font-weight: 600;">{{
                                                org_basic_data.school_name }}</h2>
                                            <h2 style="margin: 10px 0 0 0; font-size: 18px; font-weight: 500;">Quiz Mark
                                                Analysis Report</h2>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="2" class="text-right schl-logo">
                                            <img v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo"
                                                alt="School Logo" style="height: 120px;" />
                                        </v-col>
                                    </v-row>
                                </div>

                                <v-row dense class="mb-5 mt-5 d-flex justify-center">
                                    <v-col cols="12" sm="3" md="3">
                                        <strong class="d-block text-center">Academic Year : {{ display_ay }}</strong>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <strong class="d-block text-center">Standard : {{ display_standard }}</strong>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <strong class="d-block text-center">Division : {{ display_division }}</strong>
                                    </v-col>
                                </v-row>

                                <div v-for="(quiz, qIndex) in report_data" :key="quiz.quiz_id" class="mb-10">
                                    <v-row align="center" justify="center" class="mb-4">
                                        <v-col cols="auto">
                                            <h3>Quiz Name: {{ quiz.quiz_name }}</h3>
                                        </v-col>
                                        <v-col cols="auto">
                                            <h3>Course Name: ({{ quiz.course }})</h3>
                                        </v-col>
                                    </v-row>
                                    <v-simple-table dense class="elevation-1">
                                        <thead>
                                            <tr>
                                                <th class="text-center">Sr No.</th>
                                                <th class="text-center">Learner Name</th>
                                                <th class="text-center">Total Marks</th>
                                                <th class="text-center">Marks Obtained</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="(learner, index) in quiz.learners" :key="learner.learner_id">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ learner.learner_name }}</td>
                                                <td>{{ learner.total_marks }}</td>
                                                <td>{{ learner.marks_obtained }}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                                <br /><br />
                                <v-row dense class="mt-8" style="width: 100%; align-items: center;">
                                    <v-col cols="4" class="text-left" style="padding-left: 40px;">
                                        <strong>Subject Teacher</strong>
                                    </v-col>
                                    <v-col cols="4" class="text-center">
                                        <strong>Exam Incharge</strong>
                                    </v-col>

                                    <v-col cols="4" class="text-right" style="padding-right: 40px;">
                                        <strong>Principal</strong>
                                    </v-col>
                                </v-row>
                            </div>
                        </span>
                    </span>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";
import "@/assets/css/color.css";
export default {

    data() {
        return {
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            fetch_loader: false,
            show: false,
            default_value: null,

            ay_list: [],
            selected_ay: "",
            selected_section: "",
            selected_sem: "",
            selected_standard: "",
            selected_division: "",
            selected_course:"",
            display_ay: "",
            display_standard: "",
            display_division: "",
            section_list: [],
            semester_list: [],
            standard_list: [],
            division_list: [],
            quiz_list :[],
            course_list:[],
            report_data: [],
            org_basic_data: []
        };
    },

    methods: {

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        getreport() {
            if (!this.selected_ay || !this.selected_standard || !this.selected_division || !this.selected_course || !this.selected_quiz) {
                this.showSnackbar("#b71c1c", "Select the all fields...");
                return
            }
            const data = {
                selected_ay: this.selected_ay,
                selected_standard: this.selected_standard,
                division: this.selected_division,
                quiz : this.selected_quiz,
                course : this.selected_course
            };
            axios
                .post("/QuizScheduling/getQuizMarkReport", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.report_data = res.data.quizReport;
                        this.org_basic_data = res.data.org_basic_data;
                        this.display_ay = res.data.display_ay;
                        this.display_standard = res.data.display_standard;
                        this.display_division = res.data.display_division;
                    }

                    if (!this.report_data || this.report_data.length === 0) {
                        this.showSnackbar("#b71c1c", "No data found");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.fetch_loader = false;
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/QuizScheduling/getAllData")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;
                        this.standard_list = res.data.standard_list
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => { });
        },
        getDivisions() {
            const data = {
                ay: this.selected_ay,
                standard: this.selected_standard
            }
            axios
                .post("/QuizScheduling/getDivisionsOfAy", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.division_list = res.data.division_list;
                        this.course_list = res.data.course_list;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => { });
        },
         getQuizzes() {
            const data = {
                ay: this.selected_ay,
                division : this.selected_division,
                standard: this.selected_standard,
                course : this.selected_course
            }
            axios
                .post("/QuizScheduling/getQuizzes", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                       const list = res.data.quiz_list;

                        if (Array.isArray(list) && list.length > 0) {
                            this.quiz_list = [
                                { id: "ALL", quiz_name: "All" },
                                ...list
                            ];
                        } else {
                            this.quiz_list = [];
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => { });
        },
        
        downloadFile() {
            this.loader = true;

            if (!this.report_data || !this.report_data.length) {
                this.showSnackbar("#b71c1c", "No data available to export");
                this.loader = false;
                return;
            }

            let excelData = [];
            let srNo = 1;

            this.report_data.forEach((quiz) => {
                quiz.learners.forEach((learner) => {
                    excelData.push({
                        "Sr No": srNo++,
                        "Learner Name": learner.learner_name,
                        "Course Name": quiz.course,
                        "Quiz Name": quiz.quiz_name,
                        "Total Marks": learner.total_marks,
                        "Marks Obtained": learner.marks_obtained
                    });
                });
            });

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Quiz Mark Analysis Report");
            XLSX.writeFile(workbook, "QuizMarkAnalysisReport.xlsx");
            this.loader = false;
        },
    },
    mounted() {
        this.onload();
    },
};
</script>
<style>
tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

#print-table th,
.printing_area th {
    font-size: 10pt;
    /* increase header font */
    font-weight: bold;
    text-align: center;
}

/* Table data: smaller font */
#print-table td,
.printing_area td {
    font-size: 10pt;
    /* decrease data font */
    text-align: center;
    padding: 4px 6px;
}

/* Optional: make the table full width and compact */
#print-table,
.printing_area table {
    width: 100%;
    border-collapse: collapse;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem i !important;
}

.mytable /deep/ thead th {
    background: #0f2027 !important;
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 12px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880;
    right: 0;
}


.header {
    border: 1px solid gray;
    margin: 10px;
}

@media print {

    body,
    html {
        width: 210mm;
        height: 297mm;
        margin: 0 !important;
        padding: 0 !important;
    }

    body * {
        visibility: hidden !important;
    }

    .printing_area,
    .printing_area * {
        visibility: visible !important;
    }

    .printing_area {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        margin: 0 !important;
        padding: 0 !important;
    }

    .printing_area .v-row,
    .printing_area .v-col {
        margin: 0 !important;
        padding: 0 !important;
    }

    .printing_area .header {
        margin: 0 !important;
        padding: 2px 0 !important;
        border: 1px solid gray;
    }

    .printing_area h2 {
        font-size: 16px !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .printing_area .trust-logo img {
        width: 80px !important;
        height: 100px !important;
        margin: 0 0 0 10px !important;
    }

    .printing_area .schl-logo img {
        width: 140px !important;
        height: 100px !important;
        margin: 0 !important;
    }

    .printing_area strong {
        font-size: 12px !important;
    }

    .printing_area table {
        width: 100% !important;
        border-collapse: collapse !important;
    }

    .printing_area td,
    .printing_area th {
        font-size: 9pt !important;
        padding: 2px 3px !important;
        line-height: 1.1 !important;
        border: 1px solid #ccc !important;
    }

    /* Ensure header repeats and has padding on new pages */
    .printing_area thead {
        display: table-header-group !important;
    }

    .printing_area thead tr th {
        padding-top: 10px !important;
        /* top padding for new page */
    }

    .printing_area tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        height: auto !important;
    }

    .printing_area tbody {
        page-break-inside: auto !important;
    }

    .v-breadcrumbs,
    .v-app-bar,
    .v-navigation-drawer,
    .v-toolbar,
    .v-input,
    .v-btn {
        display: none !important;
    }

    @page {
        size: A4 portrait;
        margin: 5mm;
        /* small margin so content is near top on first page */
    }
}
</style>